import { inject, Injectable, NgZone } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class ScrollDisableService {

    private readonly document = inject(DOCUMENT);
    private readonly zone = inject(NgZone);

    constructor() {
        this.zone.runOutsideAngular(() => {
            this.document.addEventListener('wheel', this.onWheel, { passive: false });
            this.document.addEventListener('keydown', this.onKeydown);
        });
    }

    private readonly onWheel = (event: WheelEvent): void => {
        const target = event.target as HTMLInputElement;
        if (target.tagName === 'INPUT' && target.type === 'number') {
            event.preventDefault();
        }
    };

    private readonly onKeydown = (event: KeyboardEvent): void => {
        const target = event.target as HTMLInputElement;
        if (
            target.tagName === 'INPUT' &&
            target.type === 'number' &&
            (event.key === 'ArrowUp' || event.key === 'ArrowDown')
        ) {
            event.preventDefault();
        }
    };
}
